module.exports = __webpack_public_path__ + "4673609434d99102b569566f4b7c4be9.svg";